import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

// API
import * as API  from '../../utils/api'

// Components
import FormInput from '../../components/Global/Forms/FormInput'
import SchoolSearchAutocompleteInput from '../../components/Global/Forms/SchoolSearchAutocompleteInput'
import SelectFormInput from '../../components/Global/Forms/SelectFormInput'
import SplitInputContainer from '../../components/Global/Forms/SplitInputContainer'
import RadioFormInput from '../../components/Global/Forms/RadioFormInput'
import AppCanvasLoader from '../../components/Global/AppCanvasLoader'

// Utils - Data
import stateDataAbbreviations from '../../utils/data/stateAbbreviations.json'

class AthleteInfoForm extends Component {

  state = {
    input: {
      first_name: '',
      last_name: '',
      twitter_username: '',
      graduating_year: '',
      sex: '',
      height_us_feet: '',
      height_us_inches: '',
      hudl_username: '',
      school_id: '',
      school_name: '',
      weight_lbs: '',
      facebook_username:'',
      username: '',
      new_school_name: '',
      new_school_street_address: '',
      new_school_city: '',
      new_school_state: '',
      new_school_zip: '',
    },
    formErrors: {
      first_name: '',
      last_name: '',
      twitter_username: '',
      graduating_year: '',
      sex: '',
      height_us_feet: '',
      height_us_inches: '',
      hudl_username: '',
      school_id: '',
      weight_lbs: '',
      facebook_username:'',
      username: '',
      new_school_name: '',
      new_school_street_address: '',
      new_school_city: '',
      new_school_state: '',
      new_school_zip: '',
    },
    options: {
      sex: [
        {value: '0', label: 'Male'},
        {value: '1', label: 'Female'},
      ],
      height_in_feet: [
        {value: 3, label: "3'"},
        {value: 4, label: "4'"},
        {value: 5, label: "5'"},
        {value: 6, label: "6'"},
        {value: 7, label: "7'"},
      ],
      height_in_inches: [
        {value: 0, label: '0"'},
        {value: 1, label: '1"'},
        {value: 2, label: '2"'},
        {value: 3, label: '3"'},
        {value: 4, label: '4"'},
        {value: 5, label: '5"'},
        {value: 6, label: '6"'},
        {value: 7, label: '7"'},
        {value: 8, label: '8"'},
        {value: 9, label: '9"'},
        {value: 10, label: '10"'},
        {value: 11, label: '11"'},
      ],
      graduating_years: [],
    },
    currentlyAddingSchool: false,
    displayErrorMessages: false,
    formIsValid: false,
    usernameIsValid: '',
    yearOptions: [],
    isLoading: true,
  }

  componentDidMount() {
    this.populateForm(this.props)
  }

  componentWillReceiveProps(nextProps) {
      this.populateForm(nextProps)
  }

  populateForm(props) {
    const { activeProfile } = props

    this.setState(state => ({
      ...state,
      input: {
        ...state.input,
        ...this.getInitialInputs(activeProfile)
      },
      options: {
        ...state.options,
        graduating_years: this.getGraduationYearOptions()
      },
      currentlyAddingSchool: false,
      isLoading: false
    }))
  }

  getInitialInputs(data) {
    let inputs = {
      first_name: data.first_name,
      last_name: data.last_name,
      graduating_year: data.graduating_year,
      sex: data.sex.toString(),
      height_us_feet: data.height_us_feet,
      height_us_inches: data.height_us_inches,
      hudl_username: data.hudl_username,
      school_id: data.school.id,
      school_name: data.school.school_name,
      weight_lbs: data.weight_lbs ? data.weight_lbs : '',
      twitter_username: data.twitter_username,
      facebook_username: data.facebook_username,
    }

    return inputs
  }

  getGraduationYearOptions() {
    let startingYear = (new Date()).getFullYear()
    let yearOptions = []

    for (var i = 0; i < 10; i++) {
      yearOptions.push(
        {value: startingYear, label: startingYear}
      )
      startingYear += 1
    }

    return yearOptions
  }

  handleInputChange = (event) => {
    const { value, name } = event.target

    this.setState(state => ({
      ...state,
      input: {
        ...state.input,
        [name]: value
      }
    }), () => { this.updateFieldErrorMessage(name, value) })
  }

  handleSchoolSelection = (school) => {
    let school_id = school.id

    this.setState(state => ({
      ...state,
      input: {
        ...state.input,
        school_id
      }
    }), () => { this.updateFieldErrorMessage('school_id', school_id) } )
  }

  updateUsernameValidity = (username) => {
    let usernameIsAvailable = ''

    if (username.length > 0) {
      let formErrors = this.state.formErrors

      API.checkUsername(username).then(response => {
        if (response.errors) {
          usernameIsAvailable = true
        } else {
          usernameIsAvailable = false
        }

        formErrors.username = usernameIsAvailable
          ? ''
          : 'That username is already taken. Please try again'

        this.setState(state => ({
          ...state,
          formErrors,
          usernameIsValid: usernameIsAvailable
        }), () => this.turnOnErrorMessages())
      })
    } else {
      this.setState(state => ({
        ...state,
        usernameIsValid: ''
      }))
    }
  }

  handleSubmit = (event) => {
    event.preventDefault()
    const { input, currentlyAddingSchool } = this.state

    if (this.isFormValid()) {

      let submission = {
        graduating_year: input.graduating_year,
        sex: input.sex,
        height_us_feet: input.height_us_feet,
        height_us_inches: input.height_us_inches,
        weight_lbs: input.weight_lbs,
        twitter_username: input.twitter_username,
        facebook_username: input.facebook_username,
        hudl_username: input.hudl_username,
        first_name: input.first_name,
        last_name: input.last_name,
        school_id: currentlyAddingSchool ? null : input.school_id
      }

      if (currentlyAddingSchool) {
        submission.school_attributes = {
          school_name: input.new_school_name,
          address: input.new_school_street_address,
          city: input.new_school_city,
          state: input.new_school_state,
          zip: input.new_school_zip,
        }
      }

      this.setState(state => ({
        ...state,
        input: {
          ...state.input,
        },
      }), this.props.handleSubmit(submission))
    } else {
      this.setFormErrorState()
    }
  }

  setFormErrorState = () => {
    const { input, displayErrorMessages } = this.state

    Object.keys(input).map((field, i) => {
      return this.updateFieldErrorMessage(field, input[field])
    })

    if (!this.state.formIsValid && !displayErrorMessages) {
      this.toggleErrorMessages()
    }
  }

  turnOnErrorMessages() {
    this.setState(state => ({
      ...state,
      displayErrorMessages: true
    }))
  }

  toggleErrorMessages() {
    const { displayErrorMessages } = this.state

    this.setState(state => ({
      ...state,
      displayErrorMessages: !displayErrorMessages
    }))
  }

  updateFieldErrorMessage = (fieldName, value) => {
    let formErrors = this.state.formErrors

    switch(fieldName) {
      case 'username':
        formErrors.username = value.length > 0
          ? ''
          : 'Please enter a username'
        this.updateUsernameValidity(value)
        break
      case 'school_id':
        formErrors.school_id = value.toString().length > 0
          ? ''
          : 'Please select a school'
        break
      case 'graduating_year':
        formErrors.graduating_year = value.toString().length > 0
          ? ''
          : 'Please select a graduation year'
        break
      case 'sex':
        let sexValue = parseInt(value, 10)
        formErrors.sex = sexValue === 1 || sexValue === 0
          ? ''
          : 'Please complete this field'
          break
      case 'facebook_username':
      case 'twitter_username':
      case 'hudl_username':
      case 'weight_lbs':
        formErrors[fieldName] = ''
        break
      default:
        formErrors[fieldName] = value !== ''
          ? ''
          : 'Please complete this field'
        break
    }

    this.setState(state => ({
      ...state,
      formErrors,
    }))
  }

  isFormValid() {
    const {
      input,
      currentlyAddingSchool,
    } = this.state

    const { showUsernameInput } = this.props

    let inputErrorIndex = Object.keys(input).map((field, i) => {
      if (currentlyAddingSchool && field === 'school_id') {
        return true
      } else if (!currentlyAddingSchool && field.includes('new_school_')) {
        return true
      } else if (showUsernameInput === false && field === 'username') {
        return true
      } else {
        return this.isFieldValid(field, input[field])
      }
    }).indexOf(false)

    if (inputErrorIndex > -1) {
      return false
    } else {
      return true
    }
  }

  isFieldValid = (fieldName, value) => {
    switch(fieldName) {
      case 'facebook_username':
      case 'twitter_username':
      case 'hudl_username':
      case 'weight_lbs':
        return true
        // eslint-disable-next-line no-unreachable
        break
      case 'school_id':
        return value.toString().length > 0
        // eslint-disable-next-line no-unreachable
        break
      default:
        return value ? true : false
        // eslint-disable-next-line no-unreachable
        break
    }
  }

  getUsernameFieldValidity = (usernameIsValid) => {
    if (usernameIsValid === true) {
      return ' valid'
    } else if (usernameIsValid === false) {
      return ' invalid'
    } else {
      return ''
    }
  }

  renderUsernameInput() {
    const {
      input,
      displayErrorMessages,
      formErrors,
      usernameIsValid
    } = this.state

    const { showUsernameInput } = this.props

    return showUsernameInput
    ? (
      <FormInput
        label="Choose a Username"
        placeholder="Username"
        name="username"
        type="text"
        value={input.username}
        onChange={this.handleInputChange}
        optionalClasses={`validate-container${this.getUsernameFieldValidity(usernameIsValid)}`}
        showError={displayErrorMessages}
        errorMessage={formErrors.username}
      >
        <p className="note">Once selected, your unique username cannot be changed, and will be used as a custom Locker Linked url. lockerlinked.com/{input.username}</p>
      </FormInput>
    ) : null
  }

  renderSchoolSelectionInputs(asdf) {
    const {
      currentlyAddingSchool,
      input,
      formErrors,
      displayErrorMessages,
    } = this.state

    return currentlyAddingSchool
    ? (
      <div className="add-school">
        <div className="athlete-info-school-header">
          <label>
            Add a High School
          </label>
          <p>
            <a
              className="text-link"
              onClick={this.toggleAdditionalSchoolFields}
            >
              Cancel
            </a>
          </p>
        </div>
        <hr/>
        <FormInput
          label="School Name"
          placeholder="School Name"
          name="new_school_name"
          type="text"
          value={input.new_school_name}
          onChange={this.handleInputChange}
          showError={displayErrorMessages}
          errorMessage={formErrors.new_school_name}
        />
        <FormInput
          label="Street Address"
          placeholder="Street Address"
          name="new_school_street_address"
          type="text"
          value={input.new_school_street_address}
          onChange={this.handleInputChange}
          showError={displayErrorMessages}
          errorMessage={formErrors.new_school_street_address}
        />
        <SplitInputContainer
          showErrors={displayErrorMessages}
          errorMessages={[formErrors.new_school_city, formErrors.new_school_state, formErrors.new_school_zip]}
        >
          <FormInput
            optionalClasses="add-school-secondary-address-city"
            label="City"
            placeholder="City"
            name="new_school_city"
            type="text"
            value={input.new_school_city}
            onChange={this.handleInputChange}
            showError={displayErrorMessages}
            errorMessage={formErrors.new_school_city}
          />
          <SelectFormInput
            optionalClasses="add-school-secondary-address-state"
            label="State"
            placeholder="--"
            name="new_school_state"
            type="select"
            value={input.new_school_state}
            onChange={this.handleInputChange}
            errorMessage={formErrors.new_school_state}
            selectOptions={stateDataAbbreviations}
            showError={displayErrorMessages}
          />
          <FormInput
            optionalClasses="add-school-secondary-address-zip"
            label="Zip"
            placeholder="Zip"
            name="new_school_zip"
            type="number"
            value={input.new_school_zip}
            onChange={this.handleInputChange}
            showError={displayErrorMessages}
            errorMessage={formErrors.new_school_zip}
          />
        </SplitInputContainer>
        <hr/>
      </div>
    )
    : (
      <div>
        <div className="athlete-info-school-header">
          <label htmlFor="school">
            High School
          </label>
          <p>
            Not listed?&nbsp;
            <a
              className="text-link"
              onClick={this.toggleAdditionalSchoolFields}
            >
              Add a School
            </a>
          </p>
        </div>
        <SchoolSearchAutocompleteInput
          schoolSearchType='high school'
          onChange={(selectedSchool) => this.handleSchoolSelection(selectedSchool)}
          defaultInputValue={input.school_name}
          showError={displayErrorMessages}
          errorMessage={formErrors.school_id}
        />
        <p className="smaller note">Don't see your school? Type the full name of your high school followed by city and state.</p>
      </div>
    )
  }

  toggleAdditionalSchoolFields = () => {
    this.setState(state => ({
      ...state,
      currentlyAddingSchool: !this.state.currentlyAddingSchool
    }))
  }

  formatSocialMediaUrl(url) {
    if(url.includes('http://') || url.includes('https://')) {
      return url;
    } else {
      return 'https://' + url;
    }
  }

  render() {
    const {
      input,
      formErrors,
      displayErrorMessages,
      isLoading,
      options,
    } = this.state

    const { submitButtonText } = this.props

    return isLoading
    ? (
      <AppCanvasLoader />
    )
    : (
      <form
        onSubmit={this.handleSubmit}
        className="athlete-info-form"
      >
        <SplitInputContainer
          showErrors={displayErrorMessages}
          errorMessages={[formErrors.first_name, formErrors.last_name]}
        >
          <FormInput
            label="Athlete's First Name"
            placeholder="First Name"
            name="first_name"
            type="text"
            value={input.first_name}
            onChange={this.handleInputChange}
            showError={displayErrorMessages}
            errorMessage={formErrors.first_name}
          />
          <FormInput
            label="Athlete's Last Name"
            placeholder="Last Name"
            name="last_name"
            type="text"
            value={input.last_name}
            onChange={this.handleInputChange}
            showError={displayErrorMessages}
            errorMessage={formErrors.last_name}
          />
        </SplitInputContainer>
        {this.renderUsernameInput()}
        {this.renderSchoolSelectionInputs(input)}
        <SelectFormInput
          label="Graduating Year"
          name="graduating_year"
          type="select"
          value={input.graduating_year}
          placeholder="Select a Year..."
          onChange={this.handleInputChange}
          errorMessage={formErrors.graduating_year}
          optionalClasses="select-container"
          selectOptions={options.graduating_years}
          showError={displayErrorMessages}
        />
        <RadioFormInput
          label="Sex"
          name="sex"
          selectedOption={input.sex}
          showError={displayErrorMessages}
          errorMessage={formErrors.sex}
          onChange={this.handleInputChange}
          options={options.sex}
          optionalClasses="radio-containers-half"
        />
        <SplitInputContainer
          showErrors={displayErrorMessages}
          errorMessages={
            [
              formErrors.height_us_feet,
              formErrors.height_us_inches
            ]
          }
        >
          <SplitInputContainer
            label="Height"
          >
            <SelectFormInput
              name="height_us_feet"
              type="select"
              value={input.height_us_feet}
              onChange={this.handleInputChange}
              errorMessage={formErrors.height_us_feet}
              optionalClasses="select-container"
              placeholder="Ft."
              selectOptions={options.height_in_feet}
            />
            <SelectFormInput
              name="height_us_inches"
              type="select"
              value={input.height_us_inches}
              onChange={this.handleInputChange}
              errorMessage={formErrors.height_us_inches}
              optionalClasses="select-container"
              placeholder="In."
              selectOptions={options.height_in_inches}
            />
          </SplitInputContainer>
          <FormInput
            label="Weight in Lbs (optional)"
            placeholder="Enter Weight"
            name="weight_lbs"
            type="number"
            value={input.weight_lbs}
            onChange={this.handleInputChange}
          />
        </SplitInputContainer>
        <h3>Social</h3>
        <p>
          Connect your Locker Linked profile to your favorite social networks and share with your friends.
        </p>
        <blockquote>
          Make sure to copy and paste full social media URLs.
        </blockquote>
        <FormInput
          label="Twitter Profile URL (optional)"
          placeholder="Enter Twitter Profile Address"
          name="twitter_username"
          optionalClasses="social-profile-input"
          type="text"
          value={input.twitter_username}
          onChange={this.handleInputChange}
          errorMessage={formErrors.twitter_username}
          showError={displayErrorMessages}
        >
          <div className="sublabel">
            Example: https://twitter.com/BillSmith20
          </div>
          { input.twitter_username &&
            <p className="note">
              <Link
                to={this.formatSocialMediaUrl(input.twitter_username)}
                target="_blank"
                className="text-link"
              >
                Click here to double check that this is your correct Twitter profile
              </Link>
            </p>
          }
        </FormInput>
        <FormInput
          label="Facebook Profile URL (optional)"
          placeholder="Enter Facebook Profile Address"
          name="facebook_username"
          optionalClasses="social-profile-input"
          type="text"
          value={input.facebook_username}
          onChange={this.handleInputChange}
          errorMessage={formErrors.facebook_username}
          showError={displayErrorMessages}
        >
          <div className="sublabel">
            Example: https://facebook.com/bill.smith
          </div>
          { input.facebook_username &&
            <p className="note">
              <Link
                to={this.formatSocialMediaUrl(input.facebook_username)}
                target="_blank"
                className="text-link"
              >
                Click here to double check that this is your correct Facebook profile
              </Link>
            </p>
          }
        </FormInput>
        <FormInput
          label="Hudl Profile URL (optional)"
          placeholder="Enter Hudl Profile Address"
          name="hudl_username"
          optionalClasses="social-profile-input"
          type="text"
          value={input.hudl_username}
          onChange={this.handleInputChange}
          errorMessage={formErrors.hudl_username}
          showError={displayErrorMessages}
        >
          <div className="sublabel">
            Example: https://hudl.com/profile/11214192/Bill-Smith
          </div>
          { input.hudl_username &&
            <p className="note">
              <Link
                to={this.formatSocialMediaUrl(input.hudl_username)}
                target="_blank"
                className="text-link"
              >
                Click here to check your Hudl profile
              </Link>
            </p>
          }
        </FormInput>
        <input
          type="submit"
          className="cta-gradient"
          value={submitButtonText ? submitButtonText : 'Submit'}
          onClick={this.handleSubmit}
        />
      </form>
    )
  }
}

const mapStateToProps = state => {
  return {
    user: state.user,
    accountDetails: state.accountDetails,
    activeProfile: state.activeProfile
  }
}

export default connect(
  mapStateToProps,
  null
)(AthleteInfoForm)



// WEBPACK FOOTER //
// ./src/components/Forms/AthleteInfoForm.js